import ContentCard from "../../../ui/ContentCard";
import ContentCardTitle from "../../../ui/ContentCardTitle";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import ComprehensiveHistoryTable from "../history-section/ComprehensiveHistoryTable";
import ExchangeHistoryTable from "../history-section/ExchangeHistoryTable";
import styles from "../../../styles/Components/exchange-portfolio/ExchangeTradeHistory.module.css";

function ExchangeTradeHistory() {
  const {
    exchangeState: {
      exchangeHistoryLoading,
      selectedPortfolioExchange,
      exchangeComprehensiveHistoryLoading,
      exchangeHistory,
      exchangeComprehensiveHistory,
      exchangeComprehensiveHistoryError,
      exchangeHistoryError,
      integratedDataLoading,
    },
  } = useSelector((state) => state);

  const [currentMode, setCurrentMode] = useState("positions");

  return (
    <ContentCard>
      <div className={styles.header}>
        <ContentCardTitle title="Trade History" />
        <div className={styles.tableModeSwitcher}>
          <span
            className={`${styles.switcherBtn} ${currentMode === "positions" ? styles.active : ""}`}
            onClick={() => setCurrentMode("positions")}
          >
            Positions
          </span>
          <span
            className={`${styles.switcherBtn} ${currentMode === "orders" ? styles.active : ""}`}
            onClick={() => setCurrentMode("orders")}
          >
            Orders
          </span>
        </div>
      </div>
      {currentMode === "orders" && (
        <ExchangeHistoryTable
          exchange={selectedPortfolioExchange}
          data={exchangeHistory}
          loading={exchangeHistoryLoading || integratedDataLoading}
          error={exchangeHistoryError}
        />
      )}
      {currentMode === "positions" && (
        <ComprehensiveHistoryTable
          type="exchange"
          exchange={selectedPortfolioExchange}
          loading={exchangeComprehensiveHistoryLoading || integratedDataLoading}
          historyData={exchangeComprehensiveHistory}
          error={exchangeComprehensiveHistoryError}
        />
      )}
    </ContentCard>
  );
}

export default ExchangeTradeHistory;
